export const residentialLocationQuestions = [
  {
    questionNumber: 1,
    choices: {
      A: "There are porches with railings.",
      B: "Windows are being closed.",
      C: "Trees are being planted.",
      D: "A roof is being installed.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 난간이 있는 현관이 있음\n" +
      "오답 설명: (B) 창문은 이미 닫혀있는 상태이며 닫고 있는 사람이 없음, (C) 나무는 이미 심어져 있음, (D) 지붕은 이미 설치된 상태이며 설치하는 사람이 없음",
  },
  {
    questionNumber: 2,
    choices: {
      A: "Some letters are being placed in the mailboxes.",
      B: "A package is left on the floor.",
      C: "A mailbox is being closed.",
      D: "Mailboxes are attached to the wall.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 설명: (D) 우편함이 벽에 부착되어 있음\n" +
      "오답 설명: (A) 편지가 우편함에 넣어지는 모습은 보이지 않음, (B) 바닥에 소포가 없음, (C) 우편함은 이미 닫혀있으며 닫고 있는 사람이 없음",
  },

  {
    questionNumber: 3,
    choices: {
      A: "The door is being closed.",
      B: "The windows are covered with curtains.",
      C: "Plants are being placed by the entrance.",
      D: "The steps lead to the entrance.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 설명: (D) 계단이 입구로 이어져 있음\n" +
      "오답 설명: (A) 문은 이미 닫힌 상태임, (B) 창문에 커튼이 없음, (C) 식물은 이미 놓여있으며 놓고 있는 사람이 없음",
  },

  {
    questionNumber: 4,
    choices: {
      A: "A porch light is being installed.",
      B: "A package is left on the porch.",
      C: "The steps are covered with plants.",
      D: "Columns are supporting the roof.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 설명: (D) 기둥들이 지붕을 받치고 있음\n" +
      "오답 설명: (A) 현관등이 설치되는 장면이 보이지 않음, (B) 현관에 택배가 없음, (C) 계단에 식물이 덮여있지 않음",
  },

  {
    questionNumber: 5,
    choices: {
      A: "An awning is shading the balcony.",
      B: "A sitting area is being placed.",
      C: "Plants are being placed.",
      D: "A curtain is drawn across the window.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 차양이 발코니를 가리고 있음\n" +
      "오답 설명: (B) 좌석 공간은 이미 설치되어 있음, (C) 식물은 이미 놓여져 있음, (D) 창문에 커튼이 아니라 덧문이 있음",
  },
  {
    questionNumber: 6,
    choices: {
      A: "A rug is placed under the sofa.",
      B: "A book has been placed on the table.",
      C: "Several cushions have been arranged on the sofa.",
      D: "A lamp is being installed on the ceiling.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 소파에 여러 개의 쿠션이 놓여있음\n" +
      "오답 설명: (A) 러그가 소파 아래가 아닌 소파 앞쪽에 깔려있음, (B) 테이블 위에 책이 없음, (D) 조명은 이미 설치되어 있음",
  },
  {
    questionNumber: 7,
    choices: {
      A: "The rug has been rolled up.",
      B: "A chair is being moved near the table.",
      C: "Some cushions are leaning against the armrest.",
      D: "Books are being placed on the shelf.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 쿠션들이 팔걸이에 기대어 있음\n" +
      "오답 설명: (A) 러그가 말려있지 않고 바닥에 깔려있음, (B) 의자가 움직이는 중이 아님, (D) 책을 놓는 장면은 없으며 책은 이미 선반에 있음",
  },
  {
    questionNumber: 8,
    choices: {
      A: "A fireplace is being installed.",
      B: "Curtains are covering the windows.",
      C: "A rug is being rolled up.",
      D: "A painting has been hung above the fireplace.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 설명: (D) 벽난로 위에 그림이 걸려있음\n" +
      "오답 설명: (A) 벽난로는 이미 설치되어 있음, (B) 커튼이 있지만 창문을 가리지 않고 한쪽으로 쳐져있음, (C) 러그가 말리는 중이 아님",
  },

  {
    questionNumber: 9,
    choices: {
      A: "A book has been placed on the floor.",
      B: "A lamp has been positioned behind a chair.",
      C: "The wall is being filled with bricks.",
      D: "Some boxes are stacked on the table.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 램프가 의자 뒤에 놓여있음\n" +
      "오답 설명: (A) 책은 바닥이 아닌 테이블 위에 있음, (C) 벽은 이미 벽돌로 지어져 있음, (D) 상자들은 테이블이 아닌 선반 위에 있음",
  },
  {
    questionNumber: 10,
    choices: {
      A: "A microwave has been placed on the counter.",
      B: "A dishwasher has been opened.",
      C: "A refrigerator door is left open.",
      D: "Pendant lights have been hung from the ceiling.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 설명: (D) 천장에 펜던트 조명이 걸려있음\n" +
      "오답 설명: (A) 전자레인지는 카운터가 아닌 벽장 위에 있음, (B) 식기세척기는 닫혀있는 상태임, (C) 냉장고 문이 닫혀있음",
  },

  {
    questionNumber: 11,
    choices: {
      A: "Pendant lights have been installed above the counter.",
      B: "A cutting board is being used.",
      C: "Water is running from the faucet.",
      D: "A dish rack is placed next to the sink.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 조리대 위에 펜던트 조명이 설치되어 있음\n" +
      "오답 설명: (B) 도마가 있지만 사용하는 사람이 없음, (C) 수도꼭지는 있지만 물이 나오지 않음, (D) 접시 건조대가 보이지 않음",
  },
  {
    questionNumber: 12,
    choices: {
      A: "Utensils are being placed in a container.",
      B: "A cutting board has been placed on the counter.",
      C: "Kitchen utensils have been hung on the wall.",
      D: "Water is being poured from the faucet.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 주방 도구들이 벽에 걸려있음\n" +
      "오답 설명: (A) 도구들은 이미 용기에 담겨있음, (B) 도마가 보이지 않음, (D) 수도꼭지에서 물이 나오지 않음",
  },

  {
    questionNumber: 13,
    choices: {
      A: "The pot lid is opened.",
      B: "Several drawers have been pulled open.",
      C: "A cutting board is being used.",
      D: "The utensils have been placed on the counter.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 여러 개의 서랍이 열려있음\n" +
      "오답 설명: (A) 냄비 뚜껑은 닫혀있음, (C) 도마가 사용되는 중이 아님, (D) 조리 도구는 카운터가 아닌 서랍 안에 있음",
  },
  {
    questionNumber: 14,
    choices: {
      A: "A towel is hanging on the rack.",
      B: "A faucet is being installed in the sink.",
      C: "A mirror has been mounted above the sink.",
      D: "A shower gown is hanging on the wall.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 거울이 세면대 위에 설치되어 있음\n" +
      "오답 설명: (A) 수건 걸이는 있지만 수건이 없음, (B) 수도꼭지는 이미 설치되어 있음, (D) 샤워 가운이 보이지 않음",
  },

  {
    questionNumber: 15,
    choices: {
      A: "A laundry basket is being carried across the room.",
      B: "A washing machine door has been left open.",
      C: "A towel has been folded on top of the washing machine.",
      D: "The shelves are being installed on the wall.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 세탁기 문이 열려있는 상태임\n" +
      "오답 설명: (A) 세탁 바구니는 움직이지 않고 제자리에 있음, (C) 수건은 세탁기 위가 아닌 다른 곳에 있음, (D) 선반은 이미 설치되어 있음",
  },
  {
    questionNumber: 16,
    choices: {
      A: "The washing machine is being loaded with clothes.",
      B: "A laundry basket has been placed on a stool.",
      C: "Detergents are placed on the washing machine.",
      D: "Laundry is being taken out.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 세탁 바구니가 의자 위에 놓여있음\n" +
      "오답 설명: (A) 세탁기에 옷을 넣는 사람이 없음, (C) 세제가 보이지 않음, (D) 빨래를 꺼내는 사람이 없음",
  },
  {
    questionNumber: 17,
    choices: {
      A: "A towel is being folded on top of the washing machine.",
      B: "A laundry basket has been placed near the window.",
      C: "Clothes have been hung on a drying rack.",
      D: "Detergent bottles are being refilled.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 옷들이 건조대에 걸려있음\n" +
      "오답 설명: (A) 수건은 접혀있는 상태이며 접는 중이 아님, (B) 세탁 바구니는 창문 근처가 아닌 세탁기 옆에 있음, (D) 세제 병에 내용물을 채우는 장면은 없음",
  },
  {
    questionNumber: 18,
    choices: {
      A: "Towels have been stacked on the shelves.",
      B: "A rug is being laid on the floor.",
      C: "A washing machine door has been left open.",
      D: "Clothes are being hung up.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 수건들이 선반에 쌓여있음\n" +
      "오답 설명: (B) 러그는 이미 바닥에 깔려있음, (C) 세탁기 문이 닫혀있음, (D) 옷을 거는 사람이 없음",
  },

  {
    questionNumber: 19,
    choices: {
      A: "A car is being parked in the garage.",
      B: "A ladder has been mounted against the wall.",
      C: "Some bags are being packed on the shelves.",
      D: "Various tools have been stored on the wall.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 설명: (D) 다양한 도구들이 벽에 보관되어 있음\n" +
      "오답 설명: (A) 차는 이미 주차되어 있음, (B) 사다리는 벽에 기대어 있지 않고 걸려있음, (C) 가방들은 이미 선반에 정리되어 있음",
  },
  {
    questionNumber: 20,
    choices: {
      A: "A large rug is being rolled up.",
      B: "The dining table is covered with dishes.",
      C: "Several cushions are propped against the sofa.",
      D: "A staircase is being repaired.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 소파에 쿠션들이 기대어 있음\n" +
      "오답 설명: (A) 러그가 말려있지 않음, (B) 식탁 위에 그릇이 없음, (D) 계단을 수리하는 장면이 없음",
  },
  {
    questionNumber: 21,
    choices: {
      A: "Clothes are hanging on the window.",
      B: "A chair is placed near the window.",
      C: "A cushion and a blanket are placed on the windowsill.",
      D: "The curtains are closed.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 창가에 쿠션과 담요가 놓여있음\n" +
      "오답 설명: (A) 창문에 옷이 걸려있지 않음, (B) 창가 근처에 의자가 없음, (D) 커튼이 열려있음",
  },
  {
    questionNumber: 22,
    choices: {
      A: "The windowsill is empty.",
      B: "There are flowers and blankets on the windowsill.",
      C: "A cat is sitting by the window.",
      D: "The window is covered with curtains.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 창가에 꽃과 담요가 놓여있음\n" +
      "오답 설명: (A) 창가가 비어있지 않음, (C) 창가에 고양이가 없음, (D) 창문에 커튼이 쳐져있지 않음",
  },
  {
    questionNumber: 23,
    choices: {
      A: "A ceiling fan is mounted on the ceiling.",
      B: "A chandelier is hanging above the table.",
      C: "The fireplace is covered with a glass panel.",
      D: "A television is placed above the fireplace.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 천장에 실링팬이 설치되어 있음\n" +
      "오답 설명: (B) 테이블 위에 샹들리에가 없음, (C) 벽난로에 유리 패널이 없음, (D) 벽난로 위에 TV가 없음",
  },
  {
    questionNumber: 24,
    choices: {
      A: "A fireplace is built into the floor.",
      B: "A fireplace is burning brightly.",
      C: "The television is displaying a news broadcast.",
      D: "A bookshelf is placed next to the fireplace.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 벽난로에 불이 밝게 타고 있음\n" +
      "오답 설명: (A) 벽난로가 바닥에 설치되어 있지 않음, (C) TV에서 뉴스가 나오지 않음, (D) 벽난로 옆에 책장이 없음",
  },
  {
    questionNumber: 25,
    choices: {
      A: "A chair is placed against the bookshelf.",
      B: "A ladder is propped against the bookshelf.",
      C: "Some books are scattered on the floor.",
      D: "A window is covered with thick curtains.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 책장에 사다리가 기대어 있음\n" +
      "오답 설명: (A) 책장에 의자가 기대어 있지 않음, (C) 바닥에 책이 흩어져 있지 않음, (D) 창문에 두꺼운 커튼이 쳐져있지 않음",
  },
  {
    questionNumber: 26,
    choices: {
      A: "The room is decorated with furniture.",
      B: "A large table is placed in the center of the room.",
      C: "The room is unfurnished.",
      D: "The window blinds are closed.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 방이 가구가 없이 비어있음\n" +
      "오답 설명: (A) 방에 가구로 장식되어 있지 않음, (B) 방 중앙에 큰 테이블이 없음, (D) 창문 블라인드가 닫혀있지 않음",
  },
  {
    questionNumber: 27,
    choices: {
      A: "The ceiling lights are illuminating the room.",
      B: "A framed picture is propped against the wall.",
      C: "Several lamps are illuminating the living room.",
      D: "A rug is placed under the sofa.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 여러 개의 램프가 거실을 밝히고 있음\n" +
      "오답 설명: (A) 천장 조명이 아니라 스탠드 조명과 테이블 램프가 방을 밝히고 있음, (B) 액자는 벽에 걸려 있고, 벽에 기대어 놓인 것이 아님, (D) 러그는 소파 아래가 아닌 소파 앞 테이블 아래에 깔려 있음",
  },
  {
    questionNumber: 28,
    choices: {
      A: "Several unfinished houses are under construction.",
      B: "Workers are painting the exterior of a house.",
      C: "The houses are ready for sale.",
      D: "The buildings have been fully completed.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 여러 채의 미완성된 집이 건설 중이므로 정답\n" +
      "오답 설명: (B) 노동자들이 페인트칠을 하는 모습이 보이지 않으므로 오답, (C) 집이 완공된 상태가 아니므로 오답, (D) 건물들이 완전히 지어진 상태가 아니므로 오답",
  },
  {
    questionNumber: 29,
    choices: {
      A: "Some books are stacked on the floor.",
      B: "A person is reaching for a book.",
      C: "A bookshelf is fastened to the wall.",
      D: "The shelves are empty.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 책장이 벽에 고정되어 있으므로 정답\n" +
      "오답 설명: (A) 책이 바닥에 쌓여 있지 않으므로 오답, (B) 사람이 책을 잡으려고 하는 장면이 아니므로 오답, (D) 선반이 비어 있지 않고 책과 화분이 있으므로 오답",
  },
  {
    questionNumber: 30,
    choices: {
      A: "A table is covered with a cloth.",
      B: "Part of the wall is covered with patterned wallpaper.",
      C: "A bookshelf is placed next to the sofa.",
      D: "A window is open.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 벽의 일부가 패턴이 있는 벽지로 덮여 있으므로 정답\n" +
      "오답 설명: (A) 테이블에 천이 덮여 있지 않으므로 오답, (C) 소파 옆에 책장이 없으므로 오답, (D) 창문이 열려 있는 장면이 보이지 않으므로 오답",
  },
];
